// extracted by mini-css-extract-plugin
module.exports = {"dark":"FIpOJIHmHN-button-theme-dark-dark","shadowed":"s6TQNAZqnh-button-theme-dark-shadowed"};